import React, { useEffect, useCallback, useState} from 'react';
import {STORE, LINK_TYPES} from 'decentralized/artists/constants.js';
import {connect} from 'react-redux';
import {newSampleByArtist, getArtistInfo, newArtistInfo, getArtistForSample} from 'decentralized/artists/Artists.js';
import Dropdown from 'react-dropdown';

let counter=0;
const UnsourcedFlow = ({sample, samples=[sample], show=false}) => { 
    sample = samples[0];
    let [artistName, setArtistName] = useState(undefined);
    let [alreadyMatched, setAlreadyMatched] = useState(false);
    let [artistInfo, setArtistInfo] = useState(undefined);
    let [showFlow, setShowFlow] = useState(show);
    let [linkType, setLinkType] = useState(STORE);
    let [artistValue, setArtistValue] = useState('');
    let [websiteValue, setWebsiteValue] = useState('');

    useEffect(() => {
        setAlreadyMatched(true);
        getArtistForSample(sample.ipfsHash).then(
            ret => {
                setArtistName(ret);
                if (ret) {
                    getArtistInfo(ret).then(
                        info => setArtistInfo(info));
                } else {
                    setArtistInfo(undefined);
                }
            });
    }, [sample, setArtistName, setArtistInfo, setAlreadyMatched]);

    const saveArtistInfo = useCallback(() => {
        samples.forEach(
            s => 
                newSampleByArtist(artistValue, s.ipfsHash));
        if (!alreadyMatched) {
            newArtistInfo(artistValue, linkType, websiteValue);
        }
        setArtistInfo({
            artistName: artistValue,
            link: websiteValue,
            linkType
        });
        setArtistName(artistValue);
        setShowFlow(false);
        setAlreadyMatched(true);
    }, [
        artistValue,
        setAlreadyMatched,
        websiteValue,
        linkType,
        setArtistInfo,
        setShowFlow,
        samples,
        alreadyMatched]);

    const onChangeArtistName = useCallback((e) => {
        setAlreadyMatched(false);
        let v = e.target.value;
        let id= ++counter;
        setTimeout(() => {
            if (id === counter) {
                getArtistInfo(v).then(
                    ret => {
                        setArtistInfo(ret);
                        if (ret) {
                            setLinkType(ret.linkType);
                            setWebsiteValue(ret.link);
                            setAlreadyMatched(true);
                        }
                    });
            }
        }, 150);
        setArtistValue(v);
    }, [setArtistValue, setWebsiteValue, setAlreadyMatched, setLinkType]);

    if (showFlow) {
        return (
            <div className="artist-flow show">
              <input
                className="artist-flow-input"
                placeholder="Artist Name" value={artistValue} type="text" onChange={onChangeArtistName}/>
              <Dropdown
                options={LINK_TYPES}
                onChange={(o) => setLinkType(o.value)}
                value={LINK_TYPES.find(x => x.value === linkType)}
                placeholder="Website Type" />
 
              <input
                className="artist-flow-input"
                placeholder="Website" value={websiteValue} type="text" onChange={(e) => setWebsiteValue(e.target.value)}/>
              <div
                onClick={saveArtistInfo}
                className="artist-save-button">
                Save
              </div>
            </div>
        );
    }

    if (!artistName) {
        return (
            <div></div>
        );
    }

    return (
        <div className="artist-flow">
          {artistName ?
           <div className="artist-name">{artistName}</div> :
           <div
             onClick={() => setShowFlow(true)}
             className="match-artist-button">
             Match Sample To Artist
           </div>
          }
          {artistInfo ? <a target="_blank" href={artistInfo.link}>{artistInfo.link}</a> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnsourcedFlow);
